module.exports = __webpack_public_path__ + "static/media/Gilroy-ExtraBold.421abbfe.eot";